import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef, useState } from "react";
import { applyFieldConditions, computeScore, evaluateFormConditions, getMatchingFieldConditions, isFormSubmittable } from "@/utils/form";

/** Live state for an in-progress dynamic form. */

/** Manages response, conditional schema, tags and scoring for a dynamic form. */
export function useDynamicForm(form, initialResponse) {
  var _form$name, _form$response2;
  var initialResponseRef = useRef(initialResponse);
  var _useState = useState({}),
    response = _useState[0],
    setResponse = _useState[1];
  var _useState2 = useState([]),
    schema = _useState2[0],
    setSchema = _useState2[1];
  var _useState3 = useState(undefined),
    tags = _useState3[0],
    setTags = _useState3[1];
  useEffect(function () {
    var _form$schema$observat, _form$response, _initialResponseRef$c;
    if (!form) return;
    setSchema((_form$schema$observat = form.schema.observations) !== null && _form$schema$observat !== void 0 ? _form$schema$observat : []);
    setResponse(_objectSpread(_objectSpread({}, (_form$response = form.response) !== null && _form$response !== void 0 ? _form$response : {}), (_initialResponseRef$c = initialResponseRef.current) !== null && _initialResponseRef$c !== void 0 ? _initialResponseRef$c : {}));
    setTags(form.schema.tags);
  }, [form]);
  useEffect(function () {
    var _form$schema$tags_val, _form$schema$tags, _form$schema$tags2;
    if (!(form !== null && form !== void 0 && (_form$schema$tags_val = form.schema.tags_validation) !== null && _form$schema$tags_val !== void 0 && _form$schema$tags_val.length)) return;
    var actions = evaluateFormConditions(form.schema.tags_validation, response);
    var tagAction = actions.find(function (action) {
      return action.type === "update_tag";
    });
    setTags(_objectSpread(_objectSpread({}, (_form$schema$tags = form.schema.tags) !== null && _form$schema$tags !== void 0 ? _form$schema$tags : {}), {}, {
      value: tagAction ? tagAction.value : (_form$schema$tags2 = form.schema.tags) === null || _form$schema$tags2 === void 0 ? void 0 : _form$schema$tags2.value
    }));
  }, [response, form]);
  var setFieldValue = function setFieldValue(id, value) {
    var _field$conditions;
    var field = schema.find(function (item) {
      return item.id === id;
    });
    var next = _objectSpread(_objectSpread({}, response), {}, _defineProperty({}, id, value));
    if (field !== null && field !== void 0 && (_field$conditions = field.conditions) !== null && _field$conditions !== void 0 && _field$conditions.length) {
      var matched = getMatchingFieldConditions(field.conditions, value);
      var applied = applyFieldConditions(schema, matched, next);
      setSchema(applied.schema);
      next = applied.response;
    }
    setResponse(next);
  };
  return {
    schema: schema,
    response: response,
    tags: tags,
    score: computeScore((_form$name = form === null || form === void 0 ? void 0 : form.name) !== null && _form$name !== void 0 ? _form$name : "", response),
    submittable: isFormSubmittable(schema, response, (_form$response2 = form === null || form === void 0 ? void 0 : form.response) !== null && _form$response2 !== void 0 ? _form$response2 : {}),
    setFieldValue: setFieldValue
  };
}